export default {
  showMobileMenu (state, val) {
    state.showMobileMenu = val
  },
  addScene (state, scene) {
    state.currentScenes.push(scene)
  },
  resetScenes (state) {
    state.currentScenes = []
  },
  toggleChanging (state) {
    state.changing = !state.changing
  },
  setCurrentSectors (state, sectors) {
    state.currentSectors = sectors
  },
  updateCurrentSectors (state, sectors) {
    state.availableSectors = sectors
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js